<div [ngSwitch]="type">
  <div class="select" *ngSwitchCase="'Drop Down'">
    <select class="form-control" placeholder="Select options" [(ngModel)]="answeroptionid">
      <option *ngFor="let option of options" [value]="option.answerChoiceId">
        {{option.answerText}}
      </option>
    </select>
  </div>
  <div class="radio" *ngSwitchCase="'Radio Buttons'">

    <div *ngFor="let option of options">
      <!-- <div *ngFor="let option of options" [ngClass]="{'horz-radio':horzColumn}" > -->

      <label style="font-size: 14px; padding-bottom: .3rem;"
        [ngClass]="{'color-checked':answeroptionid ==option.answerChoiceId}">
        <input type="radio" class="regular-radio" name="{{option.issueQuestionId}}" [(ngModel)]="answeroptionid"
          (change)="onChange(option,'Radio')" value="{{option.answerChoiceId}}" [disabled]="columnDisable" style="vertical-align: middle;">
        {{option.answerText}}
      </label> <br>
      <div *ngIf="option.isShow">
        <div *ngFor="let ans of option.subAnswerList" style="padding-left: 10px;">

          <label style="font-size: 16px; padding-bottom: .3rem;"
            [ngClass]="{'color-checked':option.subAnswerText ==ans.nestedAnswerChoiceId}">
            <input type="radio" class="regular-radio" name="{{ans.answerHeadId}}" [(ngModel)]="option.subAnswerText"
              (change)="onChange(ans,'Submenu')" value="{{ans.nestedAnswerChoiceId}}" [disabled]="columnDisable">
            {{ans.answerText}}
          </label> <br>
          <div *ngIf="ans.subChoiceOtherOption" class="col-md-5">
            <input type="text" [(ngModel)]="ans.remarks" class="form-control">

          </div>

        </div>
      </div>
    </div>

  </div>


  <div class="check" *ngSwitchCase="'Check Boxes'">
    <div *ngFor="let option of options">

      <label style="font-size: 16px; padding-bottom: .3rem;" [ngClass]="{'color-checked':option.isChecked}">
        <input type="checkbox" name="{{option.issueQuestionId}}" [(ngModel)]="option.isChecked" class="regular-checkbox"
          (change)="onChange(option,'Check')" [disabled]="columnDisable"> {{option.answerText}}
      </label> <br>
      <div *ngIf="option.isShow">

        <div *ngFor="let ans of option.subAnswerList " style="padding-left: 10px;">

          <label style="font-size: 16px; padding-bottom: .3rem;"
            [ngClass]="{'color-checked':option.subAnswerText ==ans.nestedAnswerChoiceId}">
            <input type="radio" class="regular-radio" name="{{ans.answerHeadId}}" (change)="onChange(ans,'Submenu')"
              [(ngModel)]="option.subAnswerText" value="{{ans.nestedAnswerChoiceId}}" [disabled]="columnDisable">
            {{ans.answerText}}

          </label> <br>

        </div>
      </div>


    </div>
  </div>
  <div class="check" *ngSwitchCase="'Text Box'">
    <input type="text" [(ngModel)]="anstext" class="form-control" [disabled]="columnDisable">
  </div>
  <div class="texarea" *ngSwitchCase="'Text Area'">

    <textarea class="form-control" rows="7" [(ngModel)]="comments" style="width: 96%;"
      (change)="onChange(comments,'Text Area')" [disabled]="columnDisable"></textarea>

  </div>


</div>